import { OS_NAMES } from '../constants';

import type { AppDownLoadLinks } from '../Footer';

export const getAppDownloadLink = (appDownLoadLinks: AppDownLoadLinks, osName: string) => {
  const { appStoreLink, googlePlayLink, trackingLink } = appDownLoadLinks;

  let appDownloadLink: string;
  switch (osName) {
    case OS_NAMES.ANDROID:
      appDownloadLink = `${trackingLink}?$desktop_url=${googlePlayLink}`;
      break;
    case OS_NAMES.IOS:
      appDownloadLink = `${trackingLink}?$desktop_url=${appStoreLink}`;
      break;
    default:
      appDownloadLink = trackingLink;
  }

  return appDownloadLink;
};
